import { Alert, Button } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { availableTo } from '@app/configs/dateTime';
import { mapLithuanianToLocalTime } from '@app/utils/time';
const EvaluationSuccessful = ({ onProceed }) => {
    const { t } = useTranslation();
    const time = mapLithuanianToLocalTime(availableTo);
    return (<Alert title={t('financing.evaluation_successful.title')} variant="info">
            <div className="body-m">
                {`${t('financing.evaluation_successful.message')} `}
                <span className="font-bold">{t('financing.evaluation_successful.note', { time })}</span>
                {` ${t('financing.evaluation_successful.request_evaluation_notice')}`}
            </div>
            <Button type="button" variant="primary" className="my-2 text-xs font-medium px-3 py-2 w-full md:w-auto" onClick={onProceed} label={t('financing.evaluation_successful.create_loan_application')}/>
        </Alert>);
};
export default EvaluationSuccessful;
